import * as React from "react";
import PropTypes from "prop-types";

const ChevronRight = ({
  alt = "Chevron Right",
  className = "",
  size = 24
}) => (
  <svg
    aria-label={alt}
    className={`chevron ${className}`}
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    role="img"
    viewBox="0 0 24 24"
  >
    <title id="ChevronRight">{alt}</title>
    <path
      fill="#241C15"
      fillRule="evenodd"
      d="M13.586 12 9.293 7.707l1.414-1.414L16.414 12l-5.707 5.707-1.414-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

ChevronRight.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
};

export default ChevronRight;